import { render } from "./DocumentCard.vue?vue&type=template&id=1bf8c0e8&ts=true"
import script from "./DocumentCard.vue?vue&type=script&lang=ts"
export * from "./DocumentCard.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__